import React from "react";
import EditableText from "./EditableText";
import { trustees } from "../mock";

const Trustees = () => {
  return (
    <section id="trustees" className="w-full bg-[#d6d7c5] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <EditableText id="trustees.title" as="h2"
            className="text-center block text-[#1a1a1a] font-semibold mb-12 md:mb-16"
            style={{ fontFamily: "'Quicksand', system-ui, sans-serif", fontSize: "clamp(2.4rem, 5vw, 4rem)" }}>
          Trustees
        </EditableText>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 md:gap-5">
          {trustees.map((t, i) => (
            <div key={t.name} className="trustee-card flex flex-col items-center">
              <div className="w-[160px] h-[210px] rounded-[14px] overflow-hidden shadow-lg ring-1 ring-black/10 bg-[#c69a82]">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  draggable={false}
                />
              </div>
              <div className="mt-3 w-full bg-[#c69a82] text-[#1a1a1a] rounded-[22px] px-4 py-5 min-h-[150px] text-center shadow-md">
                <EditableText id={`trustee.${i}.name`} as="p" className="trustee-name font-bold text-sm md:text-base">
                  {t.name}
                </EditableText>
                <EditableText id={`trustee.${i}.role`} as="p" multiline className="mt-2 text-sm leading-snug block">
                  {t.role}
                </EditableText>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trustees;
